import slugify from 'slugify'
import regexCreator from 'emoji-regex'

const createSlug = text => {
	slugify.extend({
		Ä: 'ae',
		ä: 'ae',
		Ü: 'ue',
		ü: 'ue',
		Ö: 'oe',
		ö: 'oe',
	})

	return slugify(
		text
			.toLowerCase()
			.trim()
			.substring(0, 75)
	)
}

const cleanTitle = text => {
	if (text) {
		const emojiRegex = regexCreator()

		return text.replace(emojiRegex, '').trim()
	}

	return false
}

export { createSlug, cleanTitle }
